import React from "react";

const SelectedAthleteBox = ({ selected, onClick }) => {
  return (
    <>
      {selected.length > 0 &&
        selected.map((athlete) => {
          let icon = "";
          if (athlete.easy) {
            icon = "🤑";
          } else if (athlete.hard) {
            icon = "🤞";
          } else if (athlete.promo) {
            icon = "🍀";
          }

          return (
            <div className="sb-athlete-box mb-3" key={`${athlete.athlete_id}-${athlete.stat_key}`}>

              <div className="position-absolute rm-box">
                <button
                    onClick={onClick}
                    value={athlete.athlete_id}
                    data-prop="delete"
                    data-stat={athlete.stat_key}
                    className="rm-card"
                  >
                    <i className="fa-solid fa-circle-xmark"></i>
                </button>
              </div>

              <div className="row h-100">

                <div className="col-4 d-flex align-items-end">
                    <img
                      alt={athlete.name}
                      src={athlete.image}
                      height="85"
                    />
                </div>

                <div className="col-8 d-flex align-items-center">
                  <div className="mx-auto">
                    {/* <span className="sport ml-2">{athlete.league}</span> */}
                    <div className="card-txt mt-1">
                      {athlete.name}
                    </div>

                    <div className="sb-btns mx-auto">
                      <div
                        className={
                          "sb-btn" +
                          (athlete.selected == "more" ? " selected" : "")
                        }
                      >
                        <button
                          onClick={athlete.selected == "more" ? "" : onClick}
                          value={athlete.athlete_id}
                          data-prop="more"
                          data-stat={athlete.stat_key}
                        >
                          More
                        </button>
                      </div>

                      {!athlete.easy && !athlete.hard && !athlete.promo && (
                        <div
                          className={
                            "sb-btn" +
                            (athlete.selected == "less" ? " selected" : "")
                          }
                        >
                          <button
                            onClick={athlete.selected == "less" ? "" : onClick}
                            value={athlete.athlete_id}
                            data-prop="less"
                            data-stat={athlete.stat_key}
                          >
                            Less
                          </button>
                        </div>
                      )}
                    </div>

                    <div className="card-txt stats">
                      {athlete.stat} {icon} {athlete.stat_display}<br/>
                    </div>

                  </div>
                </div>

              </div>
            </div>
          );
        })}
    </>
  );
};

export default SelectedAthleteBox;
